export default __webpack_public_path__ + "static/featureImg3-b27d0f5ebf1a6591d1dc76cf15a58396.png";